import { parseSIKItem } from "../../utils/parseSikSearchResult";
import {
  MainItemType,
  SikSearchMoreResponseType,
  SikSearchResponseType,
} from "../../types/SikSearchResponseType";
import { useCallSikSearchCoworker } from "./useCallSikSearchCoworker";

export const useTransformSikSearch = (
  searchQuery: string,
  shouldHideSPRItems: boolean = false,
  shouldSkipSikSearch: boolean = false
) => {
  const {
    data: sikResponse,
    isLoading,
    isError,
    fetchNextPage,
  } = useCallSikSearchCoworker(searchQuery, shouldSkipSikSearch);

  let allItems;
  let totalItems: number = 0;

  const filterSPRItems = (item: MainItemType) =>
    shouldHideSPRItems ? item.product.itemType !== "SPR" : true;

  if (!isLoading && !isError && sikResponse) {
    const firstPageItems =
      (sikResponse?.pages[0] as SikSearchResponseType)?.searchResultPage
        ?.products?.main?.items || [];

    totalItems = (sikResponse?.pages[0] as SikSearchResponseType)
      ?.searchResultPage?.products?.badge;

    const otherPageItems = sikResponse?.pages
      .slice(1)
      .flatMap((page) => (page as SikSearchMoreResponseType)?.more?.items);

    allItems = firstPageItems
      .concat(otherPageItems || [])
      .filter(filterSPRItems)
      .map((item) => parseSIKItem(item?.product));
  }
  return {
    isError,
    isLoading,
    data: { items: allItems, totalItems: totalItems },
    fetchNextPage,
  };
};
